import React from 'react';
import PropTypes from "prop-types";
import {Modal} from "antd";
import {i18, trb} from "../../../Utilities";
import "./extraCheckModal.less"

const ExtraCheckModal = props => {
    const { visible, onOk, onCancel, data } = props;
    if(Object.keys(data).length === 0) {
        onOk();
        return null
    };
    return (
        <Modal
            visible={visible}
            onOk={onOk}
            onCancel={onCancel}
            okText = {trb(i18.Labels.CheckModalOk)}
            cancelText = {trb(i18.Labels.CheckModalCancel)}
            title={trb(i18.Labels.CheckModalTitle)}
        >
            <ul className="extra-check-modal">
                <div className="extra-check-modal__title">{data.clientEmail && trb(i18.Labels.ClientProfile)}</div>
                {data.clientEmail && <li>{trb(i18.Labels.ClientEmail)} - <b>{data.clientEmail}</b></li>}
                {data.clientPhoneNo && <li>{trb(i18.Labels.PhoneNumber)} - <b>{data.clientPhoneNo}</b></li>}
                {data.addressCountry && <li>{trb(i18.Labels.AddressCountry)} - <b>{data.addressCountry}</b></li>}
                {data.addressCity && <li>{trb(i18.Labels.AddressCity)} - <b>{data.addressCity}</b></li>}
                {data.addressStreet && <li>{trb(i18.Labels.AddressStreet)} - <b>{data.addressStreet}</b></li>}

                <div className="extra-check-modal__title">{data.clientCeoSurname && trb(i18.Labels.ClientCeo)}</div>
                {data.clientCeoName && <li>{trb(i18.Labels.ClientCeoName)} - <b>{data.clientCeoName}</b></li>}
                {data.clientCeoSurname && <li>{trb(i18.Labels.ClientCeoSurname)} - <b>{data.clientCeoSurname}</b></li>}
                {data.clientCeoPhone && <li>{trb(i18.Labels.PhoneNumber)} - <b>{data.clientCeoPhone}</b></li>}

                <div className="extra-check-modal__title">{data.clientRepSurname && trb(i18.Labels.ClientRep)}</div>
                {data.clientRepName && <li>{trb(i18.Labels.ClientRepName)} - <b>{data.clientRepName}</b></li>}
                {data.clientRepSurname && <li>{trb(i18.Labels.ClientRepSurname)} - <b>{data.clientRepSurname}</b></li>}
                {data.clientRepPhoneNo && <li>{trb(i18.Labels.PhoneNumber)} - <b>{data.clientRepPhoneNo}</b></li>}
            </ul>
        </Modal>
    );
};

ExtraCheckModal.prototype = {
    visible: PropTypes.bool,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    data: PropTypes.object,
}

export default ExtraCheckModal;